import { Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { Download, X } from "lucide-react";
import { useState } from "react";
import { db } from "@/lib/storage";

const DISMISS_KEY = "notaku:backup-reminder-dismissed";
const SEVEN_DAYS = 7 * 24 * 3600 * 1000;

/** Banner lembut kalau backup terakhir >7 hari & ada ≥5 nota baru. */
export function BackupReminder() {
  const { data: prefs } = useQuery({ queryKey: ["prefs"], queryFn: () => db.getPrefs() });
  const { data: notes = [] } = useQuery({ queryKey: ["notes"], queryFn: () => db.getNotes() });
  const [dismissed, setDismissed] = useState<boolean>(() => {
    if (typeof window === "undefined") return true;
    const at = Number(localStorage.getItem(DISMISS_KEY) || 0);
    return Date.now() - at < 3 * 24 * 3600 * 1000; // hilang 3 hari
  });

  if (!prefs || dismissed) return null;
  const last = prefs.lastBackupAt ? new Date(prefs.lastBackupAt).getTime() : 0;
  const newNotes = notes.length - (prefs.notesAtLastBackup || 0);
  const stale = !last || Date.now() - last > SEVEN_DAYS;
  if (!stale || newNotes < 5) return null;

  return (
    <div className="relative rounded-2xl border border-border bg-amber-50 dark:bg-amber-500/10 text-amber-900 dark:text-amber-100 p-3 pr-9 shadow-soft flex items-start gap-3">
      <Download className="h-5 w-5 shrink-0 mt-0.5" />
      <div className="text-sm min-w-0 flex-1">
        <div className="font-medium">Backup dulu yuk</div>
        <div className="opacity-80 mt-0.5">
          {last ? `${newNotes} nota baru sejak backup terakhir.` : `Belum pernah backup — data cuma di HP ini.`}
        </div>
        <Link
          to="/pengaturan"
          className="tap inline-flex items-center gap-1.5 mt-2 rounded-full bg-amber-600 dark:bg-amber-500 text-white px-3 py-1.5 text-sm font-medium"
        >
          Backup sekarang
        </Link>
      </div>
      <button
        aria-label="Tutup"
        onClick={() => {
          try { localStorage.setItem(DISMISS_KEY, String(Date.now())); } catch { /* ignore */ }
          setDismissed(true);
        }}
        className="tap absolute top-2 right-2 p-1 rounded-full text-amber-900/70 dark:text-amber-100/70 hover:bg-amber-200/50"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
